import getApi from '../../api'
import { Tympanogram } from '../../model/Audiometry'

export const updateTympanogram = (id: number, payload: Partial<Tympanogram>) =>
  getApi().put<Tympanogram>(`/audiometry/tympanograms/${id}`, payload)
